import { generateKeyBetween, generateNKeysBetween } from 'fractional-indexing';

/**
 * Sibling order is stored as fractional index keys so that moving one node
 * never requires rewriting its siblings. Keys compare with plain `<`.
 */
export function isValidPosition(key: string | null | undefined): key is string {
  if (!key) return false;
  try {
    generateKeyBetween(key, null);
    return true;
  } catch {
    return false;
  }
}

/** Like generateKeyBetween but never throws: bad or inverted bounds degrade gracefully. */
export function positionBetween(before: string | null | undefined, after: string | null | undefined): string {
  const a = isValidPosition(before) ? before : null;
  let b = isValidPosition(after) ? after : null;
  if (a !== null && b !== null && a >= b) b = null;
  return generateKeyBetween(a, b);
}

export function positionsBetween(before: string | null, after: string | null, n: number): string[] {
  const a = isValidPosition(before) ? before : null;
  let b = isValidPosition(after) ? after : null;
  if (a !== null && b !== null && a >= b) b = null;
  return generateNKeysBetween(a, b, n);
}

export function comparePositioned(
  a: { position: string; id: string },
  b: { position: string; id: string },
): number {
  if (a.position !== b.position) return a.position < b.position ? -1 : 1;
  return a.id < b.id ? -1 : a.id > b.id ? 1 : 0;
}
